<template>
  <div>
    <div>
      <div style="padding: 0px 0px 10px 0px ">菜单管理</div>
      <div style="margin: 0px 15px 10px 0px ">
        <el-button
          v-if="myResources.indexOf('/admin/resource/menus/create') !== -1"
          type="primary"
          size="mini"
          @click="e=>showMenuDialog(0)">
          创建一级
        </el-button>
      </div>
      <el-dialog :visible.sync="addVisible" @close="cleanForm('addResourceForm')" title="创建菜单">
        <el-form :model="addResourceObj" status-icon :rules="rules" label-width="80px" ref="addResourceForm" class="ruleForm">
            <el-form-item label="菜单名称" prop="resourceName">
                <el-input class="margin-space" placeholder="请输入菜单名称" v-model="addResourceObj.resourceName">
                </el-input>
            </el-form-item>
            <el-form-item label="菜单路由" prop="menuUrl">
                <el-input class="margin-space" placeholder="请输入菜单路由" v-model="addResourceObj.menuUrl">
                </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
                 <el-input class="margin-space" placeholder="请输入备注" v-model="addResourceObj.remarks">
                </el-input>
            </el-form-item>
            <div style="text-align: right" class="margin-space">
            <el-button :loading="addLoading" type="primary" @click="addConfirmClick('addResourceForm')">
                确认
            </el-button>
            </div>
        </el-form>
      </el-dialog>
      <LoadingNoDialog  :loading="menuLoading">
       <div v-if="myResources.indexOf('/admin/menus/resources') !== -1">

        <el-tree
            @node-click="nodeClick"
            :data="data"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
            <span v-if="data.resourceType !== 1" class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                    <template v-if="!data.hasResource">
                        <el-button
                            style="margin-left: 10px"
                            type="text"
                            size="mini"
                            v-if="myResources.indexOf('/admin/resource/menus/create') !== -1"
                            @click="() => append(data)">
                            创建
                        </el-button>
                    </template>
                    <template v-if="!data.children">
                        <el-button
                            type="text"
                            size="mini"
                            v-if="myResources.indexOf('/admin/menus/delete') !== -1"
                            @click="() => remove(node, data)">
                            删除
                        </el-button>
                    </template>
                </span>
            </span>
        </el-tree>
       </div>
        <div v-else style="box-sizing:border-box;padding-right:20px;" v-show="myResources.indexOf('/admin/menus/resources') ===-11">
          <el-alert
            title="无权访问"
            type="error"
            show-icon>
          </el-alert>
        </div>
      </LoadingNoDialog>

    </div>
  </div>
</template>

<script>
  import LoadingNoDialog from '../../components/LoadingNoDialog.vue'
  import axios from 'axios'
  import MethodComponent from './components/MethodComponent.vue'
  import ResourceTypeComponent from './components/ResouceTypeComponent.vue'


  const moment = require('moment')
  let id = 1000
  export default {
    name: 'Menu',
    data() {
      let urlCheck = (rule, value, callback) => {
        let reg = /^\/(a-z0-9)*/
        console.log(reg.test(value))
        if (!reg.test(value)) {
            callback(new Error("请输入以'/'开头的URL"));
        } else {
            callback();
        }
      };
      return {
        data: [],
        menuLoading: true,
        addVisible: false,
        addLoading: false,
        addResourceObj: {
          resourceName: '',
          menuUrl: '',
          remarks: '',
          parentId: 0,

        },
        rules:{
            resourceName:[
                {required:true,message:'名称不能为空',trigger:'blur'}
            ],
            menuUrl:[
                {required:true,message:'路由不能为空',trigger:'blur'},
                {validator:urlCheck,trigger:'blur'}
            ]
        },
        myResources:[]
      }
    },
    components: {
      LoadingNoDialog,
      MethodComponent,
      ResourceTypeComponent
    },
    mounted() {
      this.getMenus()
    },
    methods: {
      showMenuDialog(parentId) {
        this.addResourceObj.parentId = parentId
        this.addVisible = true
      },
      nodeClick(data){
       this.$emit('nodeClick',data)
      },
      async getMenus() {
        this.menuLoading = true
        let r = await axios.get('/admin/menus/resources', {params: {page: this.page, size: this.size,isResource:true}})
        // console.log(Object.assign({},r.data,{type:'菜单管理'}))
        this.data = this._recycle(r.data);
        this.getMyResources();
        this.menuLoading = false
      },
      async getMyResources() {
        let r = await axios.get('/admin/my-resources');
        this.myResources = r.data.map(item => item.apiUrl);
      },
      _recycle(data){
          data.forEach((item,index,arr) => {
            if(item.children && item.children.length > 0){
                if(item.children[0].resourceType === 1){
                    delete arr[index].children;
                    arr[index].hasResource = true;
                }else{
                    this._recycle(item.children);
                }
            }
          })
          return data;
      },
      cleanForm(formName){
          this.$refs[formName].resetFields();
      },
      renderContent(h, { node, data, store }) {
          if(!data.children && data.resourceType !== 1){
              return (
                <span class="custom-tree-node">
                    <span>{node.label}</span>
                    <span>
                    <el-button size="mini" type="text" on-click={ () => this.append(data) }>增加</el-button>
                        <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>删除</el-button>
                    </span>
                </span>);
          }else if(data.resourceType !== 1){
              return (
                <span class="custom-tree-node">
                    <span>{node.label}</span>
                    <span>
                        <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>删除</el-button>
                    </span>
                </span>);
          }
      },
      handleSizeChange(val) {
        this.size = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      addConfirmClick(formName) {
        this.$refs[formName].validate(async valid => {
            if(valid){
                this.addLoading = true
                let addResourceObj = Object.assign(this.addResourceObj, {resourceType: 0})
                let res = await axios.get('/admin/resource/list',{
                    params:{
                        page: this.page,
                        size: this.size,
                        parentId: addResourceObj.parentId
                    }
                })
                if(res.data && res.data.count > 0 && this.addResourceObj.parentId !== 0){
                    this.$message.error('操作非法');
                    this.addLoading = false
                    this.addVisible = false
                    return false;
                }
                let r = await axios.post('/admin/resource/menus/create', this.addResourceObj)
                if(r.code == 0){
                    this.$message.success('创建成功')
                }
                this.addLoading = false
                this.addVisible = false
                this.getMenus()
            }
        })

      },
      addClick() {
        this.addVisible = true
      },
      resourceTypeChange(val) {
        this.addResourceObj.resourceType = parseInt(val)
      },
      methodChange(val) {
        this.addResourceObj.method = val
      },
      append(data) {
        // console.info(data)
        this.addResourceObj.parentId = data.id
        this.addVisible = true
      },
      async remove(node, data) {
        this.$msgbox({
          title:'提示',
          message:`是否删除此菜单?`,
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done)=>{
            if(action==='confirm'){
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '删除中...'
              let r = await axios.delete('/admin/menus/delete', {params: {menuId: data.id}})
              if (r.code == 123) {
                this.$message.warning('存在下级菜单，不可删除')
                return
              }
              if(r.code==0){
                this.$message({
                  message:'删除成功',
                  type:'success'
                })
                instance.confirmButtonLoading = false
                done();
                this.getMenus()
              }else {
                this.$message({
                  message:'删除失败，请重试',
                  type:'error'
                })
                done();
              }
            }else{
              done()
            }
          }
        }).catch(err=>{})
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/main/permission/Menu.vue